import { i18n } from '@/lang/config.js';

export var destinationsOfManuscript = [
  { value: 0, text: i18n.tc('message.Guideline.destinationsOfManuscript.0') },
  { value: 1, text: i18n.tc('message.Guideline.destinationsOfManuscript.1') },
  { value: 2, text: i18n.tc('message.Guideline.destinationsOfManuscript.2') },
];

export var kindsOfWork = [
  { value: 0, text: i18n.tc('message.Guideline.kindsOfWork.0') },
  { value: 1, text: i18n.tc('message.Guideline.kindsOfWork.1') },
]

export var typesOfManuscript = [
    { value: 0, text: i18n.tc('message.Guideline.typesOfManuscript.0') },
    { value: 1, text: i18n.tc('message.Guideline.typesOfManuscript.1') },
    { value: 2, text: i18n.tc('message.Guideline.typesOfManuscript.2') },
];
